import { VOLUME_RECONCILE_MAX_SCAN_LIMIT } from './volumeReconcile.manifest.js';
export const volumeReconcileRules = {
    evaluate(_params) {
        return { disabled: {}, reasons: {} };
    },
    validate(params) {
        const n = params.scanLimit;
        if (typeof n !== 'number' || !Number.isFinite(n) || n < 1 || n > VOLUME_RECONCILE_MAX_SCAN_LIMIT) {
            return [
                {
                    key: 'scanLimit',
                    message: `Limite deve ser um número entre 1 e ${VOLUME_RECONCILE_MAX_SCAN_LIMIT}.`,
                },
            ];
        }
        return [];
    },
};
//# sourceMappingURL=volumeReconcile.rules.js.map